module.exports = __webpack_public_path__ + "img/virgin-mojito.d8aec887.jpg";